<template>
  <div style="width: 100%;height: 600px;">
    <xr-table ref="xrTable" :configure="configure"></xr-table>
  </div>
</template>

<script>
  export default {
    name: "villageMultiplePageSelect",
    data (){
      return {
        configure: {
          url: '/web/service?method=tCoreVillage_list',
          isShowSearch: false,
          pagination: false,
          idField: 'id',
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'villageName',
              title: '小区名称',
              width: 200,
              condition: {
                searchType: 'input',
                searchName: 'villageNameSearch',
                value:''
              },
            },
            {
              field: 'createdTime',
              title: '创建时间',
              align: 'center',
              width: 150,
              condition: {
                searchType: 'input',
                searchName: 'createdTimeSearch',
                value:''
              },
            },
            {
              field: 'remark',
              title: '备注',
              condition: {
                searchType: 'input',
                searchName: 'remarkSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ]
        },
      }
    },
    methods: {
      init() {
        this.$refs.xrTable.getData();
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let list = this.$refs.xrTable.multipleSelectionItem;
        if(list.length < 1){
          this.$message.warning('请选择一条数据！')
          return false;
        }
        let ids = this.CommonUtils.createStrByList(list, 'id');
        let names = this.CommonUtils.createStrByList(list, 'villageName');
        this.$emit('confirmMethod', ids, names);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/village/villageMultiplePageSelect.vue